import { initDatadogRum } from '../../setup_datadog_rum';
import { setupTriplePixel } from '../../triple_pixel';
import '../../setup_turbo';
import '../../controllers';

initDatadogRum();
setupTriplePixel();
